export const CANCELLATION_REASONS = [
  { label: 'Select a Reason', value: '' },
  { label: 'No Longer Need', value: 'No Longer Need' },
  { label: 'Too Busy / Not Using', value: 'Too Busy / Not Using' },
  { label: 'Too Expensive', value: 'Too Expensive' },
  { label: 'Not Useful', value: 'Not Useful' },
  { label: 'Not What I Expected', value: 'Not What I Expected' },
  { label: 'My Startup has Closed', value: 'My Startup has Closed' },
  { label: 'Technical/Website Problems', value: 'Technical/Website Problems' },
  { label: 'Issues with Services Provided', value: 'Issues with Services Provided' },
  { label: 'Other', value: 'Other' },
] as const

export const CANCELLATION_DISCOUNT_COUPON_CODE = 'CANCEL50'
export const CANCELLATION_DISCOUNT_PERCENT = 50

export function accountCancelHref(subscriptionId?: string | null) {
  if (!subscriptionId) {
    return '/account/cancel'
  }
  return `/account/cancel?subscriptionId=${encodeURIComponent(subscriptionId)}`
}

export function normalizeSubscriptionId(value?: string | null) {
  const trimmed = (value || '').trim()
  if (!trimmed || trimmed === 'null' || trimmed === 'undefined') {
    return ''
  }
  return trimmed
}
